import type { accountOrigin } from './types'
import accountOriginData from '../../data/accountOriginData.json'

export class accountOriginService {
  async getAccountOriginList(): Promise<{ data: accountOrigin[] }> {
    const accountOriginList = accountOriginData.data
    return { data: accountOriginList }
  }
}

